module.exports = __webpack_public_path__ + "img/poly-3.ef0ddfed.png";